import useSectionAnimation from '@/hooks/useSectionAnimation';

const steps = [
  {
    icon: 'ri-user-add-line',
    step: '1',
    title: 'أنشئ حسابك',
    desc: 'سجّل باستخدام رقم جوالك أو بريدك الإلكتروني، وأكمل التحقق من هويتك لضمان الشفافية.',
    color: 'bg-emerald-50 text-emerald-600',
  },
  {
    icon: 'ri-file-add-line',
    step: '2',
    title: 'أطلق حملتك',
    desc: 'أضف تفاصيل مشروعك أو قضيتك، حدد هدفك المالي، وأرسلها للمراجعة قبل النشر.',
    color: 'bg-amber-50 text-amber-600',
  },
  {
    icon: 'ri-share-line',
    step: '3',
    title: 'شارك وانتشر',
    desc: 'شارك حملتك مع أصدقائك وعائلتك عبر واتساب وتويتر وسناب شات لتصل لأكبر عدد.',
    color: 'bg-rose-50 text-rose-600',
  },
  {
    icon: 'ri-bank-card-line',
    step: '4',
    title: 'استلم دعمك',
    desc: 'تحويل مباشر لحسابك البنكي بعد اكتمال الحملة، مع خصم رسوم إدارية 5% لاستمرار المنصة.',
    color: 'bg-violet-50 text-violet-600',
  },
  {
    icon: 'ri-file-chart-line',
    step: '5',
    title: 'أغلق بتقرير',
    desc: 'شارك داعميك تقريراً شفافاً عن نتائج الحملة وكيفية إنفاق المبلغ، لبناء ثقة مستدامة.',
    color: 'bg-sky-50 text-sky-600',
  },
];

const HowItWorks = () => {
  const { ref, fadeUp, stagger } = useSectionAnimation({ threshold: 0.08 });

  return (
    <section ref={ref} className="py-20 bg-white" dir="rtl">
      <div className="max-w-7xl mx-auto px-8 md:px-12">
        <div className="text-center mb-14" style={fadeUp}>
          <span className="text-emerald-600 text-sm font-semibold tracking-wide uppercase">كيف تعمل المنصة</span>
          <h2 className="text-2xl md:text-4xl font-black text-stone-800 mt-2">خمس خطوات بسيطة</h2>
          <p className="text-stone-500 mt-3 max-w-lg mx-auto text-sm">
            من الفكرة إلى التمويل، نجعل الأمر سهلاً وشفافاً لك ولداعميك في المدينة المنورة والمملكة
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative group" style={stagger(i, 100)}>
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-0 w-full h-px bg-stone-100 z-0" style={{ left: '-50%', width: '100%' }}></div>
              )}
              <div className="relative z-10 text-center p-6 rounded-2xl border border-stone-100 hover:border-emerald-200 hover:shadow-sm transition-all duration-300 bg-white">
                <div className={`w-16 h-16 flex items-center justify-center rounded-2xl mx-auto mb-4 ${step.color}`}>
                  <i className={`${step.icon} text-2xl`}></i>
                </div>
                <div className="text-3xl font-black text-stone-100 mb-2">{step.step}</div>
                <h3 className="font-bold text-stone-800 mb-2">{step.title}</h3>
                <p className="text-stone-500 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-10 flex items-center justify-center gap-3 bg-emerald-50 border border-emerald-100 rounded-2xl px-6 py-4 max-w-2xl mx-auto" style={fadeUp}>
          <div className="w-9 h-9 flex items-center justify-center shrink-0">
            <i className="ri-heart-line text-emerald-600 text-xl"></i>
          </div>
          <p className="text-sm text-emerald-800 leading-relaxed">
            <strong>هِبة منصة غير ربحية</strong> — الرسوم الإدارية البسيطة (5%) تُستخدم حصراً لتغطية تكاليف التشغيل وضمان استمرار الخدمة لأبناء المدينة المنورة والمملكة.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
